<template>
	<CharacteristicEdit
		:value="value"
		:characteristic-items="meta.skill"
		:characteristic-type="meta.skillType"
		title="Soziale Kompetenzen"
		:nothing-allowed="{
			onlyOverall: true,
			overall: {
				text: 'Es sind keine sozialen Kompetenzen nötig'
			}
		}"
		:selected-items-config="{
			showExperience: false,
		}"
		label-set="customer"
		label-type="job-profile"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";

export default {

	components: {
		CharacteristicEdit
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},
}
</script>
